import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import BillForm from "./Forms/BillForm";
import { useRecoilValue } from "recoil";
import { Button, Grid } from "@mui/material";
import useStyles from "../../../../styles/styles";
import { configState } from "../../../../recoil/atoms";
import { CreateBillBody } from "../../../../api/payment";
import { BillApi } from '../../../../api/payment/apis/bill-api';
import { BillValidationSchema } from "./FormModel/validationSchema";

type Props = {
  appointmentID?: string;
  patientID?: string;
};

const AddPatientBills = ({ appointmentID,patientID }: Props) => {
  const classes = useStyles();  
  const config = useRecoilValue(configState);

  const addPatientBill = (values: CreateBillBody, actions: any) => {
    const patientBill = new BillApi(config);
    patientBill
      .createBill(values)
      .then((res) => {
        toast.success("Bill added successfully!");
        actions.resetForm({});
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleSubmit = (values: any, actions: any) => {
    actions.setTouched({});
    actions.setSubmitting(false);
  
    const payload = {
      patient_id: values.patient_id,
      doctor_id: values.doctor_id,
      tests: values.tests,
      clinic_fees: values.clinic_fees,
      inventory_items: values.inventory_items.map((item: any) => ({
        id: item.id,
        qty: item.qty || 1
      })),
      currency: values.currency,
      appointment_id: appointmentID,
    };
      
    addPatientBill(payload, actions);
  };

  return (
    <Formik
      initialValues={{
        patient_id: patientID!,
        appointment_id: appointmentID!,
        doctor_id: undefined,
        inventory_items: [],
        tests: [],
        clinic_fees: 0,
        currency: "",
      }}
      enableReinitialize={true}
      validationSchema={BillValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ dirty, isSubmitting }) => (
        <Form>
          <BillForm isAdding={true} />
          <Grid className={classes.buttons}>
            <Grid className={classes.wrapper}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={isSubmitting}
              >
                Add Bill
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default AddPatientBills;
